import { useTranslations } from 'next-intl';
import { BaseLineUp } from '@/app/components/icons/BaseLineUp';
import { GLOBAL_LANGUAGES_CONFIG, SITE } from '@/app/constants';
import { getHeaderTabsConfig } from '@/app/utils';
import { useLocale } from '@/i18n/routing';

export const getMenuConfig = () => {
  const locale = useLocale();
  const tHeader = useTranslations('header');
  const tSidebar = useTranslations('sidebar');
  const headerTabsConfig = getHeaderTabsConfig(tHeader, locale);
  const languageConfig =
    SITE === 'global'
      ? {
          label: tSidebar('systemItems.language'),
          href: '/',
          icon: BaseLineUp,
          key: 'language',
          children: GLOBAL_LANGUAGES_CONFIG.map(({ label, value }) => ({
            label,
            href: `/${value}`,
            key: value,
          })),
        }
      : null;

  return [...headerTabsConfig, languageConfig];
};
